/* eslint import/no-extraneous-dependencies: 0 */
/* eslint object-shorthand: 0 */
/* eslint func-names: 0 */
/* eslint max-len: 0 */
import * as Blockly from 'blockly';
import { FieldAngle } from '@blockly/field-angle';
import colors from '../utils/colors';
import options from '../utils/blocksOptions';

Blockly.Blocks.createc_planetario_luminaria_zona3 = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput('image')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/createc/LuzCalle.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput().setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_SALIDAS_LED_ON, 'HIGH'],
        [Blockly.Msg.LANG_SALIDAS_LED_OFF, 'LOW'],
      ]), 'STAT');
    this.appendDummyInput().appendField(Blockly.Msg.LANG_LUMINARIA_ZONA3).setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_LUMINARIA_ZONA3_TOOLTIP);
  },
};

Blockly.Blocks.createc_planetario_luminaria_cupula = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput('image')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/createc/planetario.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_PLANETARIO_LIGHTS_EFFECT);
    this.appendDummyInput().setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_PLANETARIO_LIGHTS_EFFECT_RAINBOW, '0'],
        [Blockly.Msg.LANG_PLANETARIO_LIGHTS_EFFECT_CASCADE, '1'],
        [Blockly.Msg.LANG_PLANETARIO_LIGHTS_EFFECT_TRANSITION, '2'],
      ]), 'STAT');
    this.appendDummyInput().appendField(Blockly.Msg.LANG_PLANETARIO_LIGHTS_DOME).setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_PLANETARIO_LIGHTS_TOOLTIP);
  },
};

Blockly.Blocks.createc_planetario_luminaria_cupula_off = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput('image')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/createc/planetario.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_PLANETARIO_LIGHTS_EFFECT_OFF);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_PLANETARIO_LIGHTS_OFF_TOOLTIP);
  },
};

Blockly.Blocks.createc_planetario_reflector = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/createc/Reflector.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendValueInput('COLOUR')
      .appendField(Blockly.Msg.LANG_BHOOT_LED_NEOPIXEL)
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput('').appendField(Blockly.Msg.LANG_PLANETARIO_REFLECTOR).setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_PLANETARIO_REFLECTOR_TOOLTIP);
  },
};

Blockly.Blocks.createc_planetario_reflector_off = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/createc/Reflector.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_PLANETARIO_REFLECTOR_OFF);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_PLANETARIO_REFLECTOR_OFF_TOOLTIP);
  },
};

Blockly.Blocks.createc_planetario_screen = {
  init: function () {
    this.setColour(colors.COLOUR_LCD);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/matriz_9_de_julio.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_PLANETARIO_SCREEN_MESSAGE_SHOW);
    this.appendDummyInput().setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_PLANETARIO_SCREEN_MESSAGE_0, '0'],
        [Blockly.Msg.LANG_PLANETARIO_SCREEN_MESSAGE_1, '1'],
        [Blockly.Msg.LANG_PLANETARIO_SCREEN_MESSAGE_2, '2'],
        [Blockly.Msg.LANG_PLANETARIO_SCREEN_MESSAGE_3, '3'],
      ]), 'STAT');
    this.appendDummyInput('').appendField(Blockly.Msg.LANG_PLANETARIO_SCREEN).setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_PLANETARIO_SCREEN_TOOLTIP);
  },
};

Blockly.Blocks.createc_planetario_telescope_degrees = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/createc/Telescopio.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput().setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SERVO_MOVE_DEGREES);
    this.appendValueInput('angulo').setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput('').appendField(Blockly.Msg.LANG_PLANETARIO_TELESCOPE).setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_PLANETARIO_TELESCOPE_TOOLTIP);
  },
};

Blockly.Blocks.createc_planetario_telescope_direction = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/createc/Telescopio.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_PLANETARIO_TELESCOPE_AIM);
    this.appendDummyInput().setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_PLANETARIO_TELESCOPE_NORTE, 'Base_Posicion_Norte'],
        [Blockly.Msg.LANG_PLANETARIO_TELESCOPE_NORESTE, 'Base_Posicion_Noreste'],
        [Blockly.Msg.LANG_PLANETARIO_TELESCOPE_ESTE, 'Base_Posicion_Este'],
        [Blockly.Msg.LANG_PLANETARIO_TELESCOPE_SURESTE, 'Base_Posicion_Sureste'],
        [Blockly.Msg.LANG_PLANETARIO_TELESCOPE_SUR, 'Base_Posicion_Sur'],
        [Blockly.Msg.LANG_PLANETARIO_TELESCOPE_SUROESTE, 'Base_Posicion_Suroeste'],
        [Blockly.Msg.LANG_PLANETARIO_TELESCOPE_OESTE, 'Base_Posicion_Oeste'],
        [Blockly.Msg.LANG_PLANETARIO_TELESCOPE_NOROESTE, 'Base_Posicion_Noroeste'],
      ]), 'STAT');
    this.appendDummyInput('').appendField(Blockly.Msg.LANG_PLANETARIO_TELESCOPE_BASE).setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_PLANETARIO_TELESCOPE_TOOLTIP);
  },
};

// Clampea a [0, 75] en vez de envolver como slider_angle_tren: es el comportamiento de prod.
const angleTelescopioValidator = function (text) {
  if (text === null) return null;
  let n = parseFloat(text || 0);
  if (Number.isNaN(n)) return null;
  n %= 360;
  if (n < 0) n = 0;
  if (n > 75) n = 75;
  return String(n);
};

Blockly.Blocks.slider_angle_telescopio = {
  init: function () {
    this.setColour(colors.COLOUR_MATH);
    this.setOutputShape(options.SHAPES.ROUND);
    this.setOutput(true, Number);
    this.appendDummyInput()
      .appendField(new FieldAngle(45, angleTelescopioValidator, { symbol: '' }), 'angulo');
  },
};
